import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AsyncPipe, DatePipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { BadgeComponent, ModalRoutingService } from '@woolworthsnz/styleguide';
import { MODAL_ROUTES } from '@woolworthsnz/shop';
import { map, Observable } from 'rxjs';
import { PartnerProductBoost } from '../card-boost-offer/card-boost-offer.models';
import { BoostsFacade } from '../../+state';
import {
	mapBoostCardProps,
	mapRewardTypeToBoostDetailsCard,
	mapRewardTypeToBoostStrap,
} from '../../helpers/boost.factory';
import { RewardValue } from '@woolworthsnz/trader-api';

@Component({
	selector: 'edr-app-boost-details-card',
	templateUrl: './boost-details-card.html',
	styleUrls: ['./boost-details-card.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DatePipe, NgIf, NgTemplateOutlet, AsyncPipe, BadgeComponent],
})
export class EDRBoostDetailsCardComponent implements OnInit {
	@Input() public offerId: string;

	public boostDetails$: Observable<PartnerProductBoost | undefined> | undefined;

	constructor(private modalRoutingService: ModalRoutingService, private boostFacade: BoostsFacade) {}

	public ngOnInit(): void {
		this.boostDetails$ = this.boostFacade.getOrFetchBoostOfferById(this.offerId).pipe(
			map((offer) =>
				offer
					? mapBoostCardProps({
							offerResponse: offer.offer,
							isBoosting: offer.isBoosting,
							hasError: offer.hasError,
					  }).partnerProductBoost
					: undefined
			)
		);
	}

	public openBoostOfferDetails(): void {
		this.modalRoutingService.open(
			MODAL_ROUTES.MODAL_OUTLET,
			MODAL_ROUTES.EDR_BOOST_DETAILS_MODAL_PATH,
			this.offerId
		);
	}

	public isPercentageDiscount(offerType: RewardValue.TypeEnum): boolean {
		return (
			offerType === RewardValue.TypeEnum.DiscountBasketPercentageOff ||
			offerType === RewardValue.TypeEnum.DiscountProductsPercentageOff
		);
	}

	public titleText(rewardValue: RewardValue): string {
		return mapRewardTypeToBoostStrap(rewardValue, undefined);
	}

	public boostOfferText({ points, value, type }: Omit<RewardValue, 'display'>): string {
		return mapRewardTypeToBoostDetailsCard({ points, value, type });
	}

	public boostOfferType({ type }: Pick<RewardValue, 'type'>): string {
		switch (type) {
			case RewardValue.TypeEnum.DiscountProductsPercentageOff:
			case RewardValue.TypeEnum.DiscountBasketPercentageOff:
			case RewardValue.TypeEnum.DiscountProductsDollarsOff:
			case RewardValue.TypeEnum.DiscountBasketDollarsOff:
			case RewardValue.TypeEnum.DiscountProductsFixedPrice:
			case RewardValue.TypeEnum.BogoFixedPrice:
			case RewardValue.TypeEnum.BogoDollarsOff:
				return 'discount';

			default:
				return 'points';
		}
	}
}
